import {
  Sparkles,
  PiggyBank,
  ShieldCheck,
  GraduationCap,
  HeartPulse,
  Calculator,
} from "lucide-react";

// Shared tool metadata used by the landing preview, /tools index, and the pages themselves.
export const TOOLS = [
  {
    id: "recommender",
    slug: "recommender",
    name: "Product Recommender",
    short: "Find products tailored to your stage.",
    blurb:
      "Answer 7 quick questions and we'll match you to the right products from our catalog.",
    duration: "Takes ~60 seconds",
    Icon: Sparkles,
    accent: "navy",
  },
  {
    id: "retirement-income",
    slug: "retirement-income",
    name: "Retirement Income",
    short: "Project your monthly income at retirement.",
    blurb:
      "See your projected nest egg and the monthly income it could produce at retirement.",
    duration: "Takes ~45 seconds",
    Icon: PiggyBank,
    accent: "gold",
  },
  {
    id: "life-insurance-needs",
    slug: "life-insurance-needs",
    name: "Life Insurance Needs",
    short: "Find your family's coverage gap.",
    blurb:
      "DIME-method estimate of how much life insurance your family actually needs.",
    duration: "Takes ~45 seconds",
    Icon: ShieldCheck,
    accent: "navy",
  },
  {
    id: "college-savings",
    slug: "college-savings",
    name: "College Savings",
    short: "Model the gap between tuition and savings.",
    blurb:
      "Forecast tomorrow's tuition and see if your savings plan will get you there.",
    duration: "Takes ~60 seconds",
    Icon: GraduationCap,
    accent: "gold",
  },
  {
    id: "medicare-eligibility",
    slug: "medicare-eligibility",
    name: "Medicare Eligibility",
    short: "Check enrollment windows and pathways.",
    blurb:
      "Confirm if you're eligible now — or how many months until you are.",
    duration: "Takes ~30 seconds",
    Icon: HeartPulse,
    accent: "navy",
  },
  {
    id: "ltc-cost",
    slug: "ltc-cost",
    name: "Long-Term Care Cost",
    short: "Estimate care costs by state and care type.",
    blurb:
      "Project the cost of home care, assisted living, or nursing-home care at age 80.",
    duration: "Takes ~45 seconds",
    Icon: Calculator,
    accent: "gold",
  },
];

export const TOOL_BY_SLUG = Object.fromEntries(TOOLS.map((t) => [t.slug, t]));
